<template>
  <div>
    <Head title="របាយការណ៍" />
    <h1 class="moul flex items-center mb-8 text-2xl">
      <Link class="flex items-center" href="/reports"><PresentationChartLineIcon class="mr-2 w-8 h-8" /> របាយការណ៍</Link>
    </h1>
    <div class="flex flex-wrap">
      <div class="mr-4 p-6 w-full dark:bg-gray-800 bg-white border border-gray-200 rounded-lg shadow lg:w-1/4">
        <a href="/reports/late">
          <h5 class="flex items-center hover:text-indigo-600 text-red-600 text-2xl font-medium"><ExclamationTriangleIcon class="mr-2 w-8" /> របាយការណ៍យឺត</h5>
        </a>
      </div>
      <div class="mr-4 p-6 w-full dark:bg-gray-800 bg-white border border-gray-200 rounded-lg shadow lg:w-1/4">
        <a href="/reports/daily_records">
          <h5 class="flex items-center hover:text-indigo-600 text-red-600 text-2xl font-medium"><ChartPieIcon class="mr-2 w-8" /> របាយការណ៍ចំណូលចំនាយ</h5>
        </a>
      </div>
      <div class="mr-4 p-6 w-full dark:bg-gray-800 bg-white border border-gray-200 rounded-lg shadow lg:w-1/4">
        <a href="/reports/closeout">
          <h5 class="flex items-center hover:text-indigo-600 text-red-600 text-2xl font-medium"><CurrencyDollarIcon class="mr-2 w-8" /> បិទបញ្ជីរ</h5>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import { PresentationChartLineIcon, ExclamationTriangleIcon, ChartPieIcon, CurrencyDollarIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Head,
    PresentationChartLineIcon,
    ExclamationTriangleIcon,
    ChartPieIcon,
    CurrencyDollarIcon,
  },
  layout: Layout,
}
</script>
